import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackPrintParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackPrint";

const useTrackPrint = (parameters: TrackPrintParameters = {}, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.util.getEventTrackerHook(ga.track.print, parameters, options);
};

export default useTrackPrint;
